'use strict';//Indicating browser should run only in java script mode

//*******PURPOSE: THIS SERVICE IS USEFUL IN COMMUNICATING WITH THE WCF METHODS OF STICKY NOTES
//*******EFFECTIVE FILES: ../Views/StickyNotes/..
//*******CREATED BY: 
//*******CREATED DATE: 
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

angular.module('EMR.Home').service('CounselorcaseloadsCommonService', ['CommonService', function (CommonService) {

	//############################### METHOD TO GET COUNSELOR CASE LOADS INFORMATION BLOCK START ###############################

	///*******PURPOSE:THIS METHOD TO GET COUNSELOR CASE LOADS INFORMATION
	///*******CREATED BY: ABDUL RAHIMAN M
	///*******CREATED DATE: 11/30/2015
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
	this.CounseloCaseLoadsGetCounselorCaseLoadesInformationInJSONFormat = function (postData) {

		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
		postData.practicemodel = EMRPracticeModel;
		// ADDED BY VINEEL FOR GETTING THE CUSTOMIZAED FIELD IN THE CURRENT MEDICATION WINDOW
		if (postData.EHRFormsSettingsInfoID == 20) {
			return CommonService.PostData('POST', CommonService.InPatientCaseloads() + "GetEHRCurrentMedicationColumnsCustomizationSelectedColumnsListInJSONFormat", postData).then(function (result) { return result; });
		}
		else { // FOR OTHER NAVIGATIONS
			return CommonService.PostData('POST', CommonService.EHR_TimeLessScheduler_Caseloads() + "GetCounselorCaseLoadesInformationInJSONFormat", postData).then(function (result) { return result; });
		}
	};
	//############################### COUNSELOR CASE LOADS STATUS LIST INFORMATION BLOCK END ###############################

	//############################### METHOD TO UPDATE COUNSELOR CASE LOADS  STATUS INFORMATION BLOCK START ###############################

}]); 